import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";

const NAVY = "#1a237e";
const PINK = "#e91e8c";

// ─── Teams per pool derived from match schedule ───────────────────────────────
// Stats: { gp, w, d, l, gd, pts }
const DIVISIONS = {
  A: {
    label: "DIVISION A",
    description:
      "4-pool with Quarter-final, Semi-final & Finals 11th & 12th ranked teams to be relegated to Division 'B'",
    finalStandings: [],
    pools: {
      "Pool A": [
        { name: "HOCKEY CHANDIGARH", gp: 2, w: 1, d: 1, l: 0, gd: 2, pts: 4 },
        { name: "HOCKEY PUNJAB", gp: 2, w: 1, d: 1, l: 0, gd: 2, pts: 4 },
        { name: "HOCKEY MAHARASHTRA", gp: 2, w: 0, d: 0, l: 2, gd: -4, pts: 0 },
      ],
      "Pool B": [
        { name: "HOCKEY JHARKHAND", gp: 2, w: 2, d: 0, l: 0, gd: 8, pts: 6 },
        {
          name: "DADRA & NAGAR HAVELI AND DAMAN & DIU HOCKEY",
          gp: 2,
          w: 1,
          d: 0,
          l: 1,
          gd: 5,
          pts: 3,
        },
        {
          name: "HOCKEY UNIT OF TAMIL NADU",
          gp: 2,
          w: 0,
          d: 0,
          l: 2,
          gd: -13,
          pts: 0,
        },
      ],
      "Pool C": [
        {
          name: "UTTAR PRADESH HOCKEY",
          gp: 2,
          w: 2,
          d: 0,
          l: 0,
          gd: 20,
          pts: 6,
        },
        { name: "HOCKEY HARYANA", gp: 2, w: 1, d: 0, l: 1, gd: -1, pts: 3 },
        { name: "MANIPUR HOCKEY", gp: 2, w: 0, d: 0, l: 2, gd: -19, pts: 0 },
      ],
      "Pool D": [
        {
          name: "HOCKEY MADHYA PRADESH",
          gp: 2,
          w: 2,
          d: 0,
          l: 0,
          gd: 11,
          pts: 6,
        },
        {
          name: "HOCKEY ASSOCIATION OF ODISHA",
          gp: 2,
          w: 1,
          d: 0,
          l: 1,
          gd: 6,
          pts: 3,
        },
        { name: "KERALA HOCKEY", gp: 2, w: 0, d: 0, l: 2, gd: -17, pts: 0 },
      ],
    },
  },
  B: {
    label: "DIVISION B",
    description:
      "2-pool with only league matches 1st & 2nd ranked teams to be promoted to Division 'A' and last two ranked teams to be relegated to Division 'C'",
    finalStandings: [
      { rank: 1,  name: "DELHI HOCKEY"        },
      { rank: 2,  name: "HOCKEY ARUNACHAL"    },
      { rank: 3,  name: "HOCKEY UTTARAKHAND"  },
      { rank: 4,  name: "CHHATTISGARH HOCKEY" },
      { rank: 5,  name: "HOCKEY KARNATAKA"    },
      { rank: 6,  name: "TELANGANA HOCKEY"    },
      { rank: 7,  name: "HOCKEY BIHAR"        },
      { rank: 8,  name: "HOCKEY BENGAL"       },
      { rank: 9,  name: "HOCKEY HIMACHAL"     },
      { rank: 10, name: "HOCKEY GUJARAT"      },
    ],
    pools: {
      "Pool A": [
        { name: "DELHI HOCKEY", gp: 4, w: 4, d: 0, l: 0, gd: 50, pts: 12 },
        { name: "HOCKEY UTTARAKHAND", gp: 4, w: 3, d: 0, l: 1, gd: 20, pts: 9 },
        { name: "TELANGANA HOCKEY", gp: 4, w: 2, d: 0, l: 2, gd: 15, pts: 6 },
        { name: "HOCKEY BENGAL", gp: 4, w: 1, d: 0, l: 3, gd: 3, pts: 3 },
        { name: "HOCKEY GUJRAT", gp: 4, w: 0, d: 0, l: 4, gd: -88, pts: 0 },
      ],
      "Pool B": [
        { name: "HOCKEY ARUNACHAL", gp: 4, w: 3, d: 1, l: 0, gd: 17, pts: 10 },
        { name: "CHHATTISGARH HOCKEY", gp: 4, w: 2, d: 1, l: 1, gd: 6, pts: 7 },
        { name: "HOCKEY KARNATAKA", gp: 4, w: 2, d: 1, l: 1, gd: 3, pts: 7 },
        { name: "HOCKEY BIHAR", gp: 4, w: 1, d: 1, l: 2, gd: -1, pts: 4 },
        { name: "HOCKEY HIMACHAL", gp: 4, w: 0, d: 0, l: 4, gd: -25, pts: 0 },
      ],
    },
  },
  C: {
    label: "DIVISION C",
    description:
      "2-pool with only league matches 1st & 2nd ranked teams to be promoted to Division 'B'",
    finalStandings: [
      { rank: 1, name: "HOCKEY MIZORAM"          },
      { rank: 2, name: "GOANS HOCKEY"            },
      { rank: 3, name: "HOCKEY ANDHRA PRADESH"   },
      { rank: 4, name: "HOCKEY JAMMU & KASHMIR"  },
      { rank: 5, name: "LE PUDUCHERRY HOCKEY"    },
      { rank: 6, name: "ASSAM HOCKEY"            },
      { rank: 7, name: "HOCKEY RAJASTHAN"        },
      { rank: 8, name: "TRIPURA"                 },
    ],
    pools: {
      "Pool A": [
        { name: "HOCKEY MIZORAM", gp: 3, w: 3, d: 0, l: 0, gd: 12, pts: 9 },
        {
          name: "HOCKEY ANDHRA PRADESH",
          gp: 3,
          w: 2,
          d: 0,
          l: 1,
          gd: 0,
          pts: 6,
        },
        {
          name: "LE PUDUCHERRY HOCKEY",
          gp: 3,
          w: 0,
          d: 1,
          l: 2,
          gd: -4,
          pts: 1,
        },
        { name: "ASSAM HOCKEY", gp: 3, w: 0, d: 1, l: 2, gd: -8, pts: 1 },
      ],
      "Pool B": [
        { name: "GOANS HOCKEY", gp: 2, w: 2, d: 0, l: 0, gd: 8, pts: 6 },
        {
          name: "HOCKEY JAMMU & KASHMIR",
          gp: 2,
          w: 1,
          d: 0,
          l: 1,
          gd: 0,
          pts: 3,
        },
        { name: "HOCKEY RAJASTHAN", gp: 2, w: 0, d: 0, l: 2, gd: -8, pts: 0 },
      ],
    },
  },
};

// ─── Standings table ──────────────────────────────────────────────────────────
function StandingsTable({ teams }) {
  const statCell = {
    padding: "12px 16px",
    textAlign: "center",
    color: "#555",
    fontWeight: 600,
    fontSize: "13px",
  };
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        overflow: "hidden",
        marginBottom: "28px",
        boxShadow: "0 2px 12px rgba(26,35,126,0.08)",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: NAVY,
          padding: "14px 20px",
          textAlign: "center",
        }}
      >
        <span
          style={{
            color: "#fff",
            fontWeight: 700,
            fontSize: "17px",
            letterSpacing: "0.5px",
            fontStyle: "italic",
          }}
        >
          Standings
        </span>
      </div>

      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr
              style={{
                borderBottom: `2px solid ${NAVY}`,
                fontSize: "11px",
                fontWeight: 700,
                color: NAVY,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              <th
                style={{
                  padding: "10px 16px",
                  textAlign: "left",
                  width: "90px",
                }}
              >
                Position
              </th>
              <th style={{ padding: "10px 16px", textAlign: "left" }}>Team</th>
              <th style={{ padding: "10px 16px", textAlign: "center" }}>GP</th>
              <th style={{ padding: "10px 16px", textAlign: "center" }}>Won</th>
              <th style={{ padding: "10px 16px", textAlign: "center" }}>
                Draw
              </th>
              <th style={{ padding: "10px 16px", textAlign: "center" }}>
                Lost
              </th>
              <th style={{ padding: "10px 16px", textAlign: "center" }}>GD</th>
              <th style={{ padding: "10px 16px", textAlign: "center" }}>
                Points
              </th>
            </tr>
          </thead>
          <tbody>
            {teams.map((team, idx) => (
              <tr
                key={team.name}
                style={{
                  borderBottom: "1px solid #e8eaf6",
                  background: idx % 2 === 0 ? "#fff" : "#f5f6fb",
                }}
              >
                {/* Position badge */}
                <td style={{ padding: "12px 16px" }}>
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: NAVY,
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 700,
                      fontSize: "13px",
                    }}
                  >
                    {idx + 1}
                  </div>
                </td>

                {/* Team with icon */}
                <td style={{ padding: "12px 16px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        background: "#e8eaf6",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill={NAVY}
                      >
                        <circle cx="12" cy="8" r="4" />
                        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
                      </svg>
                    </div>
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: "12px",
                        color: NAVY,
                        textTransform: "uppercase",
                      }}
                    >
                      {team.name}
                    </span>
                  </div>
                </td>

                {/* Stats */}
                <td style={statCell}>{team.gp}</td>
                <td style={statCell}>{team.w}</td>
                <td style={statCell}>{team.d}</td>
                <td style={statCell}>{team.l}</td>
                <td
                  style={{
                    ...statCell,
                    color:
                      team.gd > 0 ? "green" : team.gd < 0 ? "#c00" : "#555",
                  }}
                >
                  {team.gd > 0 ? `+${team.gd}` : team.gd}
                </td>

                {/* Points badge */}
                <td style={{ padding: "12px 16px", textAlign: "center" }}>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: PINK,
                      color: "#fff",
                      borderRadius: "20px",
                      minWidth: "40px",
                      padding: "4px 12px",
                      fontWeight: 700,
                      fontSize: "13px",
                    }}
                  >
                    {team.pts}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ─── Final Standings table ────────────────────────────────────────────────────
function FinalStandingsTable({ standings }) {
  if (!standings || standings.length === 0) {
    return (
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "32px",
          textAlign: "center",
          color: "#999",
          fontSize: "14px",
          boxShadow: "0 2px 12px rgba(26,35,126,0.08)",
        }}
      >
        Final standings not yet available.
      </div>
    );
  }
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        overflow: "hidden",
        marginBottom: "28px",
        boxShadow: "0 2px 12px rgba(26,35,126,0.08)",
      }}
    >
      {/* Navy header — matches pool table style */}
      <div style={{ background: NAVY, padding: "12px 20px", textAlign: "center" }}>
        <span style={{ color: "#fff", fontWeight: 700, fontSize: "15px", letterSpacing: "0.5px", fontStyle: "italic" }}>
          Final Standings
        </span>
      </div>

      {/* Two-column rows — no thead */}
      {standings.map((entry, idx) => (
        <div
          key={entry.name}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 20px",
            borderBottom: idx < standings.length - 1 ? "1px solid #e8eaf6" : "none",
            background: idx % 2 === 0 ? "#fff" : "#f5f6fb",
          }}
        >
          <span style={{ fontWeight: 600, fontSize: "12px", color: NAVY, textTransform: "uppercase" }}>
            {entry.name}
          </span>
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              background: PINK,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              fontSize: "13px",
              flexShrink: 0,
            }}
          >
            {entry.rank}
          </div>
        </div>
      ))}
    </div>
  );
}

// ─── Main page component ──────────────────────────────────────────────────────
export default function SubJuniorMensHockeyPointsTable() {
  const divisionKeys = Object.keys(DIVISIONS);
  const [activeDivision, setActiveDivision] = useState("A");
  const [activePool, setActivePool] = useState("Final Standings");

  const division = DIVISIONS[activeDivision];
  const poolKeys = Object.keys(division.pools);

  function handleDivision(key) {
    setActiveDivision(key);
    setActivePool("Final Standings");
  }

  const isFinalStandings = activePool === "Final Standings";
  const teams = !isFinalStandings ? (division.pools[activePool] || []) : [];

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: "url('/img/bghockyimg.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* ← Return */}
      <div style={{ padding: "16px 20px", textAlign: "left" }}>
        <Button
          href="/sub-junior-mens-hockey-2026"
          style={{
            backgroundColor: NAVY,
            borderColor: NAVY,
            fontSize: "12px",
            padding: "6px 16px",
          }}
        >
          ← Return
        </Button>
      </div>

      <Container style={{ maxWidth: "960px", paddingBottom: "60px" }}>
        {/* Page title */}
        <h1
          style={{
            color: NAVY,
            fontWeight: 900,
            fontSize: "clamp(22px, 4vw, 36px)",
            textAlign: "center",
            textTransform: "uppercase",
            letterSpacing: "1px",
            marginBottom: "28px",
          }}
        >
          Points Table
        </h1>

        {/* Division tabs */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginBottom: "24px",
            flexWrap: "wrap",
          }}
        >
          {divisionKeys.map((key) => (
            <button
              key={key}
              onClick={() => handleDivision(key)}
              style={{
                padding: "10px 28px",
                borderRadius: "8px",
                border: `2px solid ${NAVY}`,
                background: activeDivision === key ? NAVY : "transparent",
                color: activeDivision === key ? "#fff" : NAVY,
                fontWeight: 700,
                fontSize: "14px",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
            >
              {DIVISIONS[key].label}
            </button>
          ))}
        </div>

        {/* Pool filter pills */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            marginBottom: "24px",
          }}
        >
          {/* Final Standings tab always first */}
          <button
            onClick={() => setActivePool("Final Standings")}
            style={{
              padding: "7px 18px",
              borderRadius: "20px",
              border: `1.5px solid ${NAVY}`,
              background: isFinalStandings ? NAVY : "transparent",
              color: isFinalStandings ? "#fff" : NAVY,
              fontWeight: 600,
              fontSize: "12px",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            Final Standings
          </button>

          {poolKeys.map((pool) => (
            <button
              key={pool}
              onClick={() => setActivePool(pool)}
              style={{
                padding: "7px 18px",
                borderRadius: "20px",
                border: `1.5px solid ${NAVY}`,
                background: activePool === pool ? NAVY : "transparent",
                color: activePool === pool ? "#fff" : NAVY,
                fontWeight: 600,
                fontSize: "12px",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
            >
              {pool}
            </button>
          ))}
        </div>

        {/* Table */}
        {isFinalStandings
          ? <FinalStandingsTable standings={division.finalStandings} />
          : <StandingsTable teams={teams} />
        }
      </Container>
    </div>
  );
}
